/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Planner_CopiedInputs */

const en_control_planner_copied = /** @type {(inputs: Control_Planner_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share link copied.`)
};

const zh_control_planner_copied = /** @type {(inputs: Control_Planner_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已复制`)
};

/**
* | output |
* | --- |
* | "Share link copied." |
*
* @param {Control_Planner_CopiedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_planner_copied = /** @type {((inputs?: Control_Planner_CopiedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Planner_CopiedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_planner_copied(inputs)
	return zh_control_planner_copied(inputs)
});
export { control_planner_copied as "control.planner.copied" }